import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

// The SVG exported weird with errors. This is a hack, here be dragons...
export const ProgressCircleInProgressIcon = styled.div`
  animation: ${spin} 3s linear infinite;
  background-image:
    linear-gradient(rgba(243, 245, 248, 1), rgba(243, 245, 248, 1)),
    conic-gradient(from 90deg, rgba(64, 117, 255, 0.26), rgba(64, 117, 255, 1));
  background-origin: border-box;
  background-clip: content-box, border-box;
  border: 2px solid transparent;
  border-radius: 30px;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
`;
